
import { KohtumineTegevusTeavitus } from '@/models/KohtumineTegevus';
import { AxiosTeenus } from './axios-teenus';
import { KohtumineTegevus } from '@/models/KohtumineTegevus';

export class KohtumisedTegevusedTeenus {

    public async minuKohtumisedTegevused(): Promise<KohtumineTegevus[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<KohtumineTegevus[]>(`/api/kohtumisedtegevused/minutegevused`);

        return response?.data;
    }

    public async minuKohtumisedTegevusedTeavitused(): Promise<KohtumineTegevusTeavitus[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<KohtumineTegevusTeavitus[]>(`/api/kohtumisedtegevused/minutegevusedteavitused`);

        return response?.data;
    }
}